import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateUnhandledClients = () => {
  const queryClient = useQueryClient();

  return (debtorId?: string) => {
    queryClient.invalidateQueries({ queryKey: ['unhandledClients'] });
    queryClient.invalidateQueries({ queryKey: ['unhandled-debtors-view'] });
    if (debtorId) queryClient.invalidateQueries({ queryKey: ['unhandledClient', { debtorId }] });
  };
};
